
export const colorEstadoChip = {
    'Rechazada': { isBlack: true },
    'Anulada': { isGray: true },
    'Liberada': { isGreen: true },
    'No Liberada': { isRed: true }
};